<template>
  <base-slide-panel :isOpen="panelOpen" @closePanel="togglePanel">
    <template slot="header">
      <div class="h-16 bg-secondary dark:bg-darkblue-600 flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <base-icon name="filter"/>
          <h2 class="font-bold ml-2">Filtrar por</h2>
        </div>
        <span class="cursor-pointer" @click="togglePanel">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4 dark:bg-darkblue-800 dark:text-darkblue-200">
        <el-form
          ref="ruleForm"
        >
          <div class="lg:mb-2">

            <div v-if="(role === 'AdminDistribuidor' || role === 'SuperAdminDistribuidor' || role === 'SuperAdministrador')">
              <div v-if="role === 'SuperAdministrador'">
                <AccessibleElSelect
                  v-model="form.distribuidor.value"
                  prop="distribuidor"
                  :options="distribuidoresForAccessibleSelect"
                  :withFormItem="true"
                  id-prefix="usersfilter"
                  @select="handleSelectDistribuidor"
                >
                  <template slot="label">{{$t('distributors.distributor')}}</template>
                </AccessibleElSelect>
              </div>

              <AccessibleElSelect
                v-model="form.empresa.value"
                prop="empresa"
                :options="clientesForAccessibleSelect"
                :withFormItem="true"
                id-prefix="usersfilter"
                @select="handleSelectCliente"
                @change="handleChangeCliente"
              >
                <template slot="label">{{$t('app.client')}}</template>
              </AccessibleElSelect>
            </div>

            <div>
              <span id="users-filter-name-label" class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('configurations.username')}}</span>
              <el-form-item prop="name">
                <el-input
                  aria-labelledby="users-filter-name-label"
                  class="w-full"
                  v-model="form.name.value"
                  maxlength="50"
                >
                  <template v-if="form.name.value" slot="suffix">
                    <base-clear-input-button
                      aria-label="Limpiar campo del nombre de usuario"
                      @clear="form.name.value = ''"
                    />
                  </template>
                </el-input>
              </el-form-item>
            </div>
            <div>
              <span id="users-filter-email-label" class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('configurations.email')}}</span>
              <el-form-item prop="email">
                <el-input
                  aria-labelledby="users-filter-email-label"
                  class="w-full"
                  v-model="form.email.value"
                  maxlength="255"
                >
                  <template v-if="form.email.value" slot="suffix">
                    <base-clear-input-button
                      aria-label="Limpiar campo del email de usuario"
                      @clear="form.email.value = ''"
                    />
                  </template>
                </el-input>
              </el-form-item>
            </div>

            <div>
              <AccessibleElSelect
                v-model="form.role.value"
                prop="role"
                :options="rolesForAccessibleSelect"
                :withFormItem="true"
                id-prefix="usersfilter"
                @select="handleSelectRole"
              >
                <template slot="label">{{$t('configurations.rol')}}</template>
              </AccessibleElSelect>
            </div>

            <div>
              <AccessibleElSelect
                v-model="form.Activo.value"
                prop="Activo"
                :options="valuesForAccessibleSelect"
                :withFormItem="true"
                id-prefix="usersfilter"
              >
                <template slot="label">{{$t('app.active')}}</template>
              </AccessibleElSelect>
            </div>

            <div>
              <AccessibleElSelect
                v-model="form.tipoAuth.value"
                prop="tipoAuth"
                :options="tiposAuthForAccessibleSelect"
                :withFormItem="true"
                id-prefix="usersfilter"
                @select="handleSelectTipoAuth"
              >
                <template slot="label">{{$t('configurations.tipo_auth')}}</template>
              </AccessibleElSelect>
            </div>

             <div>
              <AccessibleElSelect
                v-model="form.nombreGrupo.value"
                prop="nombreGrupo"
                :options="gruposForAccessibleSelect"
                :withFormItem="true"
                :group="true"
                id-prefix="usersfilter"
              >
                <template slot="label">{{$t('notificationFilter.group')}}</template>
              </AccessibleElSelect>
            </div>

             <div>
              <AccessibleElSelect
                v-model="form.verTodoStatuses.value"
                prop="verTodoStatuses"
                :options="valuesForAccessibleSelect"
                :withFormItem="true"
                id-prefix="usersfilter"
              >
                <template slot="label">{{$t('configurations.ver_todo_statuses')}}</template>
              </AccessibleElSelect>
            </div>
             <div>
              <AccessibleElSelect
                v-model="form.verTodoCompanies.value"
                prop="verTodoCompanies"
                :options="valuesForAccessibleSelect"
                :withFormItem="true"
                id-prefix="usersfilter"
              >
                <template slot="label">{{$t('configurations.ver_todo_companies')}}</template>
              </AccessibleElSelect>
            </div>

            <div>
              <AccessibleElSelect
                v-model="form.conectado.value"
                prop="conectado"
                :options="valuesForAccessibleSelect"
                :withFormItem="true"
                id-prefix="usersfilter"
              >
                <template slot="label">{{$t('configurations.connected')}}</template>
              </AccessibleElSelect>
            </div>

          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button @click="togglePanel" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
      <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.apply')" @click="applyFilters"/>
    </template>
  </base-slide-panel>
</template>

<script>
import { i18n } from '@/i18n'
import { getGroupsNames } from '@/services/configurations/groups/getGroupsNames'
import { ROLES } from '@/config/roles'
import { TIPOS_AUTH } from '@/config/tipos-auth'
import { getDistributors } from '@/services/distributors/getDistributors'
import { getClients } from '@/services/clients/getClients'
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'

export default {
  name: 'filter-panel',
  components: {
    AccessibleElSelect
  },
  props: {
    panelOpen: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      vuexnamespace: 'users',
      isOpen: this.panelOpen,
      links: [],
      form: {
        id: { label: i18n.t('configurations.id'), value: '' },
        name: { label: i18n.t('configurations.username'), value: '' },
        email: { label: i18n.t('configurations.email'), value: '' },
        company: { label: i18n.t('configurations.company'), value: '' },
        role: { label: i18n.t('configurations.rol'), value: '' },
        Activo: { label: i18n.t('app.active'), value: '' },
        tipoAuth: { label: i18n.t('configurations.tipo_auth'), value: '' },
        nombreGrupo: { label: 'Grupo', value: '' },
        verTodoStatuses: { label: i18n.t('configurations.ver_todo_statuses'), value: '' },
        verTodoCompanies: { label: i18n.t('configurations.ver_todo_companies'), value: '' },
        distribuidor: { label: i18n.t('distributors.distributor'), value: '' },
        empresa: { label: i18n.t('app.client'), value: '' },
        conectado: { label: i18n.t('configurations.connected'), value: '' }
      },
      tiposAuth: TIPOS_AUTH,
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ],
      distribuidores: [],
      clientes: [],
      valuesNombresGrupos: [],
    }
  },

  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    panelOpen: {
      handler: 'panelOpenHandler'
    },
    'form.empresa.value': {
      handler: 'loadGroups'
    }
  },
  mounted: async function () {
    if (this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador') {
      const dataClients = await getClients()
      if (dataClients.blnError === true) {
        this.doFeedback(dataClients.msgError + ' [Código de error: ' + dataClients.codError + ']')
      }
      this.clientes = dataClients.Empresas

      if (this.role === 'SuperAdministrador') {
        const dataDistributors = await getDistributors()
        if (dataDistributors.blnError === true) {
          this.doFeedback(dataDistributors.msgError + ' [Código de error: ' + dataDistributors.codError + ']')
        }
        this.distribuidores = dataDistributors.Distribuidores
      }
    }

    await this.loadGroups()
    // if (gruposUsuario.Respuesta !== undefined && gruposUsuario.Respuesta.length > 0) {
    //   gruposUsuario.Respuesta.forEach(element => {
    //     if (this.valuesNombresGrupos.filter(x => x.value === element).length === 0) {
    //       const tag = { value: element, label: element }
    //       this.valuesNombresGrupos.push(tag)
    //     }
    //   })
    // }
  },
  computed: {
    listaGroupsGrouping () {
      if (this.valuesNombresGrupos.length > 0) {
        const options = []
        this.valuesNombresGrupos.forEach(x => {
          if (options.filter(y => y.label === x.Tipo).length === 0) {
            options.push(
              { label: x.Tipo, options: [] }
            )
          }
        })
        this.valuesNombresGrupos.forEach(x => {
          const index = options.map(x => x.label).indexOf(x.Tipo)
          options[index].options.push(
            {
              value: x.Nombre,
              label: x.Nombre,
            }
          )
        })
        return options
      }
      return []
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    roles: function () {
      return ROLES.filter(r => {
        if (r.only) {
          return r.only.includes(this.role)
        }
        return true
      })
    },
    distribuidoresForAccessibleSelect: function () {
      return this.distribuidores.map(item => ({
        id: item.IdDistribuidor,
        name: item.Nombre,
        value: item.Nombre
      }))
    },
    clientesForAccessibleSelect: function () {
      return this.clientes.map(item => ({
        id: item.IdEmpresa,
        name: item.Nombre,
        value: item.Nombre
      }))
    },
    rolesForAccessibleSelect: function () {
      return this.roles.map(item => ({
        id: item.id,
        name: item.name
      }))
    },
    tiposAuthForAccessibleSelect: function () {
      return this.tiposAuth.map(item => ({
        id: item.id,
        name: item.name
      }))
    },
    valuesForAccessibleSelect: function () {
      return this.values.map(item => ({
        id: item.value,
        name: item.label
      }))
    },
    gruposForAccessibleSelect: function () {
      return this.listaGroupsGrouping.map(group => ({
        label: group.label,
        options: group.options.map(opt => ({ id: opt.value, value: opt.value, name: opt.label }))
      }))
    }
  },
  methods: {
    loadGroups: async function () {
      const cliente = this.clientes.find(c => c.Nombre === this.form.empresa.value)
      const gruposUsuario = await getGroupsNames({ incluirReparto: false, idCliente: cliente?.IdEmpresa })
      if (gruposUsuario.blnError) {
        this.doFeedback(gruposUsuario.msgError + ' [Código de error: ' + gruposUsuario.codError + ']')
      } else {
        this.valuesNombresGrupos = gruposUsuario.Respuesta
      }
    },
    handleChangeCliente: function () {
      if (this.form.nombreGrupo.value) {
        this.form.nombreGrupo.value = ''
        this.doFeedback('Se han realizado cambios en el formulario: se han limpiado los filtros de grupo al cambiar el cliente.', 'info', 5000)
      }
    },
    panelOpenHandler: function (data) {
      const _temp = this.$store.getters[this.vuexnamespace + '/getMasterFilters']
      if (_temp) {
        this.resetForm()
        this.form.name.value = _temp.name !== undefined && _temp.name.value !== '' ? _temp.name.value : ''
        this.form.email.value = _temp.email !== undefined && _temp.email.value !== '' ? _temp.email.value : ''
        this.form.role.value = _temp.role !== undefined && _temp.role.value !== '' ? _temp.role.value : ''
        this.form.Activo.value = _temp.Activo !== undefined && _temp.Activo.value !== '' ? _temp.Activo.value : ''
        this.form.tipoAuth.value = _temp.tipoAuth !== undefined && _temp.tipoAuth.value !== '' ? _temp.tipoAuth.value : ''
        this.form.nombreGrupo.value = _temp.nombreGrupo !== undefined && _temp.nombreGrupo.value !== '' ? _temp.nombreGrupo.value : ''
        this.form.verTodoStatuses.value = _temp.verTodoStatuses !== undefined && _temp.verTodoStatuses.value !== '' ? _temp.verTodoStatuses.value : ''
        this.form.verTodoCompanies.value = _temp.verTodoCompanies !== undefined && _temp.verTodoCompanies.value !== '' ? _temp.verTodoCompanies.value : ''
        this.form.empresa.value = _temp.empresa !== undefined && _temp.empresa.value !== '' ? _temp.empresa.value : ''
        this.form.distribuidor.value = _temp.distribuidor !== undefined && _temp.distribuidor.value !== '' ? _temp.distribuidor.value : ''
        this.form.conectado.value = _temp.conectado !== undefined && _temp.conectado.value !== '' ? _temp.conectado.value : ''
      }
    },
    watchFormHandler: function ({ certificate, sendAlerts, automaticDownload }) {
      if (certificate !== undefined) {
        this.form.certificate = !!certificate
      }
      if (automaticDownload !== undefined) {
        this.form.automaticDownload = !!automaticDownload
      }
      if (sendAlerts !== undefined) {
        this.form.sendAlerts = !!sendAlerts
      }
    },
    togglePanel: function () {
      this.isOpen = !this.isOpen
      // this.resetForm()
      this.$emit('togglePanel')
    },
    resetForm: function () {
      this.form = {
        id: { label: i18n.t('configurations.id'), value: '' },
        name: { label: i18n.t('configurations.username'), value: '' },
        email: { label: i18n.t('configurations.email'), value: '' },
        company: { label: i18n.t('configurations.company'), value: '' },
        role: { label: i18n.t('configurations.rol'), value: '' },
        Activo: { label: i18n.t('app.active'), value: '' },
        tipoAuth: { label: i18n.t('configurations.tipo_auth'), value: '' },
        nombreGrupo: { label: 'Grupo', value: '' },
        verTodoStatuses: { label: i18n.t('configurations.ver_todo_statuses'), value: '' },
        verTodoCompanies: { label: i18n.t('configurations.ver_todo_companies'), value: '' },
        distribuidor: { label: i18n.t('distributors.distributor'), value: '' },
        empresa: { label: i18n.t('app.client'), value: '' },
        conectado: { label: i18n.t('configurations.connected'), value: '' }
      }
    },
    applyFilters: function () {
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', this.form)
      this.$emit('applyFilters', true)
      this.isOpen = !this.isOpen
      this.$emit('togglePanel')
    },
    querySearch: function (queryString, cb) {
      const links = this.links
      const results = queryString ? links.filter(this.createFilter(queryString)) : links
      // call callback function to return suggestions
      cb(results)
    },
    createFilter: function (queryString) {
      return (link) => {
        return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      }
    },
    handleSelect: function (item) {
      // console.log(item)
    },
    handleSelectCliente: function (item) {
      this.form.empresa.value = item.id
    },
    handleSelectDistribuidor: function (item) {
      this.form.distribuidor.value = item.id
    },
    handleSelectRole: function (item) {
      this.form.role.value = item.id
    },
    handleSelectTipoAuth: function (item) {
      this.form.tipoAuth.value = item.id
    }
  }
}
</script>

<style lang="scss" scoped></style>
